import { render } from "./StockMovementHistory.vue?vue&type=template&id=58d2d27b&scoped=true"
import script from "./StockMovementHistory.vue?vue&type=script&lang=js"
export * from "./StockMovementHistory.vue?vue&type=script&lang=js"

import "./StockMovementHistory.vue?vue&type=style&index=0&id=58d2d27b&scoped=true&lang=css"
import "./StockMovementHistory.vue?vue&type=style&index=1&id=58d2d27b&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58d2d27b"]])

export default __exports__